import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReceiptText, TrendingUp } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Spinner } from "../components/ui/kit";
import { fmtKc, fmtPct } from "../lib/format";
import api from "../lib/api";

export default function Ekonomika() {
  const nav = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/api/ekonomika/prehled").then((r) => setD(r.data)).catch(() => setD({})); }, []);

  if (d === null) return <div className="p-10 flex justify-center"><Spinner /></div>;

  return (
    <div data-testid="ekonomika-page">
      <PageHeader eyebrow="Ekonomika" title="Přehled"
        subtitle="Vyfakturováno, náklady a hrubá marže napříč zakázkami." />

      <div className="rounded-card bg-ink text-white p-6 mb-4 grid grid-cols-2 md:grid-cols-4 gap-6" data-testid="ekonomika-souhrn">
        <Metric l="Vyfakturováno" v={d.vyfakturovano} />
        <Metric l="Přijaté náklady" v={d.naklady} />
        <Metric l="Hrubá marže" v={d.hruba_marze} extra={`${fmtPct(d.hruba_marze_pct)} %`}
          accent={d.hruba_marze >= 0 ? "text-success" : "text-danger"} />
        <div>
          <div className="label-up text-white/40 mb-1">Po splatnosti</div>
          <div className="amount text-[20px] font-800 text-accent">{d.po_splatnosti || 0}</div>
          <div className="amount text-[11px] text-white/50 mt-1">{fmtKc(d.neuhrazeno_castka || 0)} Kč neuhrazeno</div>
        </div>
      </div>

      <button onClick={() => nav("/doklady")} data-testid="ekonomika-open-doklady"
        className="card w-full text-left px-5 py-4 flex items-center gap-3 hover:bg-inputbg">
        <ReceiptText size={18} className="text-sec" />
        <div className="flex-1">
          <div className="text-[13.5px] font-700 text-ink">Doklady</div>
          <div className="text-[12px] text-muted">Přijaté i vydané faktury, přiřazení nákladů, platby</div>
        </div>
        <TrendingUp size={16} className="text-muted" />
      </button>
    </div>
  );
}

function Metric({ l, v, extra, accent }) {
  return (
    <div>
      <div className="label-up text-white/40 mb-1">{l}</div>
      <div className={`amount text-[20px] font-800 ${accent || "text-white"}`}>{fmtKc(v || 0)} Kč</div>
      {extra && <div className="amount text-[11px] text-white/50 mt-1">{extra}</div>}
    </div>
  );
}
